// extracted by mini-css-extract-plugin
export default {"root":"ManagerApplyNow_root__CMiRy"};